import { render, staticRenderFns } from "./power_quality_card.vue?vue&type=template&id=9583edec&"
import script from "./power_quality_card.vue?vue&type=script&lang=js&"
export * from "./power_quality_card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports